module.exports = __webpack_public_path__ + "img/evoplay.50bac911.svg";